import * as Checkbox from "@radix-ui/react-checkbox";
import * as Label from "@radix-ui/react-label";

import { CheckIcon } from "@radix-ui/react-icons";
import SuggestedComedianAvatar from "../SuggestedComedianAvatar";
import { useId } from "react";

export default function ComedianCheckboxRowSkeleton() {
  const inputId = useId();

  return (
    <Label.Root
      className="flex flex-row items-center justify-between w-full gap-4 px-3 py-3 my-1 text-lg text-gray-900 transition-colors duration-200 ease-in-out rounded-md md:my-2 group hover:bg-neutral-50 active:bg-neutral-100 hover:cursor-pointer"
      htmlFor={inputId}
    >
      <SuggestedComedianAvatar />
      <div className="flex-1 w-12 h-6 overflow-hidden font-sans text-lg font-medium leading-normal text-left bg-gray-200 rounded-md opacity-50 text-ellipsis whitespace-nowrap animate-pulse" />
      <div>
        <Checkbox.Root
          name="skeleton"
          id={inputId}
          disabled
          checked={false}
          className="flex items-center justify-center transition-colors duration-200 ease-in-out border rounded-md shadow-sm disabled:opacity-50 bg-neutral-50 border-neutral-200 w-7 h-7 checked:border-primary focus:ring-orange-50 focus:ring aria-checked:border-primary"
        >
          <Checkbox.Indicator className="bg-primary/90 text-neutral-100 text-xl stroke-neutral-100 h-full w-full rounded-[5px] flex flex-col justify-center items-center">
            <CheckIcon height={20} width={20} strokeWidth={1.2} />
          </Checkbox.Indicator>
        </Checkbox.Root>
      </div>
    </Label.Root>
  );
}
